class SectionOne {
  constructor () {
    
    this.init()
  }
  
  init () {
    
    //  初始化app Store html
    this._initAppStoreHtml()
    this._oneRow() //sx 兼容第一屏排版  2019年2月18日
  }
  
  _initAppStoreHtml () {
    let html = `
    <li class="app-download">
        <a href="${window._appStore.appStore.link}" target="_blank"><img src="${window._appStore.appStore.img}?random=${window.randomString}" alt="App Store" width="100%"></a><a href="${window._appStore.google.link}" target="_blank"><img src="${window._appStore.google.img}?random=${window.randomString}" alt=" Google Play" width="100%"></a>
    </li>
    <li class="web-rq">
        <a href="javascript:;"><img src="${window._appStore.qrCode.img}" alt=""></a>
    </li>
    `
    $('.headroomFooter').html(html)
    $('.app-link').html(html)
  }

   _oneRow(){
    let iconRow = $('.iconLists')
    $(window).resize(function(event) {
      if (window.innerWidth <= 480) {
        iconRow.addClass('row')
      }else {
        iconRow.removeClass('row')
      }
    }).trigger('resize')
  }
}

export default SectionOne
